import React, { useEffect, useState } from "react";
import { DeleteForever } from "@mui/icons-material";
import { toast } from "react-toastify";
import { Customer } from "../../../../types/customers.types";
import { deleteCustomerEffect } from "../../../../stores/CustomersStore/CustomersStore.effects";
import SimpleModal from "../../../../components/SimpleModal/SimpleModal";
import { Colors } from "../../../../constants/Colors";

interface Props {
  customer: Customer;
}

const DeleteCustomer: React.FC<Props> = ({ customer }: Props) => {
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    if (!open) return;

    const unsubscribeDone = deleteCustomerEffect.doneData.watch(() => {
      toast.success("Cliente deletado com sucesso!");
      setOpen(false);
    });
    const unsubscribeFail = deleteCustomerEffect.fail.watch(
      ({ error }: any) => {
        console.log("Error Delete Customer", error);
        toast.error("Erro ao deletar cliente!");
      }
    );

    return () => {
      unsubscribeFail();
      unsubscribeDone();
    };
  }, [open]);

  const handleDelete = () => {
    deleteCustomerEffect(customer.id);
  };

  return (
    <SimpleModal
      open={open}
      setOpen={setOpen}
      Component={
        <DeleteForever
          sx={{
            color: Colors.secondary[100],
            ":hover": { opacity: "70%" },
            cursor: "pointer",
          }}
        />
      }
      onConfirm={handleDelete}
      title="Deletar"
      text="Confirma deletar?"
      confirmText="Deletar"
      cancelText="Cancelar"
    />
  );
};

export default DeleteCustomer;
